import React from 'react';
import { Box } from '@zillow/constellation-10';
import { VALUE_PROPS } from '../../../constants/tenant-screening-services';
import { ValueProp } from './ValueProp';
import images from '../../../images/ztss';

const getImageProps = (iconName: string) => {
  switch (iconName) {
    case 'form':
      return {
        imageData: images.valuePropForm,
        imageAlt: 'Form icon representing complete tenant overview',
      };
    case 'magnify':
      return {
        imageData: images.valuePropMagnify,
        imageAlt: 'Magnifying glass icon representing background checks',
      };
    case 'piggyBank':
      return {
        imageData: images.valuePropPiggyBank,
        imageAlt: 'Piggy bank icon representing application fees',
      };
    default:
      return {
        imageData: images.valuePropForm,
        imageAlt: 'Icon',
      };
  }
};

export function ValuePropsSection() {
  return (
    <Box
      css={{
        paddingTop: { base: '0', sm: 'xl', lg: '80px' },
        paddingLeft: { base: 'sm', sm: 'sm', lg: 'sm' },
        paddingRight: { base: 'sm', sm: 'sm', lg: 'sm' },
        paddingBottom: { base: 'md', sm: 'xl', lg: '80px' },
        margin: '0 auto',
        textAlign: 'center',
        display: 'flex',
        gap: 'lg',
        flexDirection: { base: 'column', lg: 'row' },
        alignItems: { base: 'center', lg: 'flex-start' },
        justifyContent: 'center',
      }}
    >
      {VALUE_PROPS.map((prop, index) => (
        <ValueProp key={index} title={prop.title} description={prop.description} {...getImageProps(prop.iconName)} />
      ))}
    </Box>
  );
}
